import loadable from '@loadable/component';

export const DcwSiteWrapper = loadable(
  () => import(/* webpackChunkName: "dcw-site" */ './DcwSiteWrapper'),
);
